<script>
  import BadgeState from "../../Stores/badgeState"
  import { drawChecked, loadImage } from "../../../File/Edit/Script/loadImg"
  import notify from "../../../../../Script/notify"
  import { validateFile } from "../../../../Publish/BulkUpload/Script/bulkUpload"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import BgRemovalModal from "../../../../../Shared/BgRemoval/index.svelte"
  import axios from "axios"
  export let operation

  let aspectRatio = 1
  let files = ""
  let maintainAspectRatio = true
  let loading = false

  let showBgRemovalModal = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  // operation.inputY = $BadgeState.baseInfo.height - operation.y
  $: operation.x = Math.floor(operation.x)
  $: operation.width = Math.floor(operation.width)
  $: operation.height = Math.floor(operation.height)
  // $: operation.inputY = Math.floor(operation.inputY)

  $: changeInputY(operation.y)

  const changeInputY = (y) => {
    operation.inputY = Math.floor($BadgeState.baseInfo.height - y)
  }

  const handleImageUpload = async (files) => {
    if (files) {
      try {
        loading = true

        await validateFile(files[0])
        let imageFile = {
          file: files[0],
        }

        const MAX_FILE_SIZE = 2 * 1024 * 1024

        if (files[0].size > MAX_FILE_SIZE) throw "Maximum File Size exceeded"

        //updating stores
        operation.src = await storeImage(imageFile)
        operation.image = await loadImage(operation.src)

        operation.aspectRatio = operation.image.naturalWidth / operation.image.naturalHeight
        maintainAspectRatio = true
        aspectRatio = operation.aspectRatio

        if (operation.width >= operation.height) {
          operation.height = Math.floor(operation.width / aspectRatio)
        } else {
          operation.width = Math.floor(operation.height * aspectRatio)
        }

        operation.uploadImage = false
      } catch (error) {
        closeNotification.close()
        const info = "PAGE: Badge Template Editor (Image Layer)\nEVENT: While uploading image"
        closeNotification = notify.danger(error, info)
        files = null
        operation.uploadImage = true
      } finally {
        loading = false
      }
    }
  }

  const storeImage = (imageFile) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.post(`/api/swagger/v2/templates/files/${$BadgeState.baseInfo.id}/image`, imageFile, {
          headers: {
            "x-access-token": $ApplicationState.token,
            "Content-Type": "multipart/form-data",
          },
        })
        //error checking while api call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        resolve(data.uri)
      } catch (error) {
        reject(error)
      }
    })
  }

  $: handleImageUpload(files)

  const moveCursor = (id) => {
    $BadgeState.operations = $BadgeState.operations.map((operation) => {
      operation.move = false
      if (operation.id == id) {
        $BadgeState.cursorPosition.x = operation.x
        $BadgeState.cursorPosition.y = operation.y
        operation.move = true
      }
      return operation
    })
  }
  $: if (operation.move) {
    operation.x = $BadgeState.cursorPosition.x
    operation.y = $BadgeState.cursorPosition.y
  }

  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }

  const handleBgRemoval = async (e) => {
    try {
      showBgRemovalModal = false
      operation.uploadImage = true
      loading = true

      console.log(files)

      let file = new File([e.detail], files ? files[0].name : operation.value, {
        type: "image/png",
      })

      //updating stores
      operation.src = await storeImage({
        file: file,
      })
      operation.image = await loadImage(operation.src)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Badge Template Editor (Image Layer)\nEVENT: While removing image background"
      closeNotification = notify.danger(error, info)
    } finally {
      operation.uploadImage = false
      loading = false
    }
  }
</script>

{#if showBgRemovalModal}
  <BgRemovalModal
    enableDarkMode={false}
    blobURL={operation.image.src}
    on:click={() => {
      showBgRemovalModal = false
    }}
    on:removeBg={handleBgRemoval}
  />
{/if}

<svelte:window on:keydown />

<div class="flex w-full flex-col gap-3 rounded-md border {operation.active ? 'border-extraBlue-500' : 'border-transparent'} {!operation.value.trim() ? 'border-yellow-500' : ''} bg-[#292A2F] p-6">
  <div class="group relative w-full rounded-md">
    <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">TITLE</div>
    <input
      type="text"
      on:keydown={(e) => {
        if (e.key == "Delete") {
          e.stopPropagation()
        }
      }}
      bind:value={operation.value}
      placeholder="Enter the value"
      class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500"
    />
  </div>
  {#if operation.type == "image"}
    {#if operation.uploadImage}
      {#if loading}
        <div>
          <div class="flex h-36 cursor-pointer flex-col items-center justify-center gap-3 rounded-md border border-stone-700 bg-transparent">
            <div class="h-20 w-20 animate-spin rounded-full border-[1px] border-gray-300 border-r-blue-500" />
          </div>
        </div>
      {:else}
        <div class="relative flex h-36 cursor-pointer flex-col items-center gap-3 rounded-md border border-stone-700 bg-transparent">
          <form id="formImageEdit">
            <input bind:files type="file" name="userImage" class="absolute inset-0 cursor-pointer opacity-0" accept=".png, .jpeg, .jpg" />
          </form>
          <span class="text-xl text-gray-g00">
            <i class="fa-solid fa-image" />
          </span>
          <div class="flex flex-col items-center justify-center">
            <p class="text-sm text-white">
              Upload Image <span>or drag and drop</span>
            </p>
            <span class="select-none pt-2 text-center text-xs font-normal text-gray-g00">Maximum Size 2MB</span>
            <span class="pt-2 text-xs text-gray-g00">Choose jpeg, jpg, png files</span>
          </div>
        </div>
      {/if}
    {:else}
      <div class="flex h-32 w-full items-center gap-3 rounded-md bg-gray-900 p-3">
        <!-- Image Section -->
        <div class="group relative flex w-2/5 items-center justify-center rounded-md bg-[#393a3d] p-1">
          <img src={operation.image.src} alt="StaticImage" class="aspect-auto max-h-[116px] max-w-full rounded-md" style="background: url(assets/img/grid.png);" />
          <button
            type="button"
            on:click={async () => {
              if (operation.width <= operation.height) operation.height = operation.width
              else operation.width = operation.height
              if ((operation.width || operation.height) <= 10) operation.width = operation.height = 10

              operation.src = drawChecked(operation.width, operation.height)
              operation.image = await loadImage(operation.src)
              operation.uploadImage = true
            }}
            class="absolute inset-0 flex items-center justify-center rounded-md bg-black/50 text-white opacity-0 transition-opacity duration-300 hover:opacity-100"
          >
            <span class="flex h-6 w-6 items-center justify-center rounded-full bg-red-500 p-1">
              <i class="fa-solid fa-xmark hover:text-white" />
            </span>
          </button>
        </div>

        <!-- File Details -->
        <div class="flex flex-col justify-between gap-2">
          <h3 class="w-40 truncate text-left text-base font-semibold text-white">{files ? files[0].name : operation.value}</h3>

          <div class="flex items-center space-x-2 text-xs text-gray-300">
            <span class="rounded-md bg-[#292a2f] px-2 py-1">{operation.width} × {operation.height} px</span>
          </div>

          <button
            on:click={() => {
              showBgRemovalModal = true
            }}
            type="button"
            class="w-fit rounded-md bg-blue-600 p-2 text-xs font-semibold text-white"
          >
            <span>
              <i class="fa-solid fa-eraser" />
            </span>
            &nbsp;&nbsp;Remove Background
          </button>
        </div>
      </div>
    {/if}
  {/if}

  {#if !operation.uploadImage}
    <div class="flex flex-col gap-1.5">
      <h1 class="text-left text-sm font-medium text-gray-500">Rotation angle (degree)</h1>
      <div class="flex w-full items-center gap-3">
        <input
          min="0"
          max="360"
          step="1"
          on:input={(e) => {
            if (!e.target.value) operation.rotation = 0
            else if (e.target.value > 360) operation.rotation = 360
            else if (e.target.value < 0) operation.rotation = 0
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.rotation}
          type="number"
          class="w-fit select-none rounded-md border border-stone-700 bg-transparent py-2 px-3 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
        <!-- <h1 class="w-20 select-none text-xl font-bold tracking-wide text-extraBlue-500">{operation.rotation ? Math.round(operation.rotation) : 0}°</h1> -->
        <input min="0" max="360" step="1" bind:value={operation.rotation} type="range" class="w-full cursor-pointer outline-none" />
      </div>
    </div>
  {/if}
  <div class="flex items-center gap-3">
    <!-- input x -->
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">X</div>
      <button
        on:click|preventDefault={() => {
          if (operation.x + 10 <= $BadgeState.baseInfo.width) {
            operation.x = operation.x + 10
          } else {
            operation.x = $BadgeState.baseInfo.width // Stop at the width boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click|preventDefault={() => {
          if (operation.x - 10 >= 0) {
            operation.x = operation.x - 10
          } else {
            operation.x = 0 // Stop at the left boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>

      <input
        min="0"
        type="number"
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        bind:value={operation.x}
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>
    <!-- input y -->

    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">Y</div>
      <button
        on:click={() => {
          if (operation.y - 10 >= 0) {
            operation.y = operation.y - 10
          } else {
            operation.y = 0 // Stop at the top boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click={() => {
          if (operation.y + 10 <= $BadgeState.baseInfo.height) {
            operation.y = operation.y + 10
          } else {
            operation.y = $BadgeState.baseInfo.height // Stop at the bottom boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>

      <input
        min="0"
        on:input={(e) => {
          operation.y = $BadgeState.baseInfo.height - e.target.value
        }}
        bind:value={operation.inputY}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        type="number"
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>

    <button data-tooltip="Move" on:click={() => moveCursor(operation.id)} tooltip-position="top" class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-extraBlue-500 active:bg-extraBlue-500">
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-arrow-pointer" />
      </span>
    </button>
  </div>
  <div class="flex gap-3">
    <!-- Width -->
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">W</div>
      <button
        on:click={async () => {
          operation.width = operation.width + 10
          if (maintainAspectRatio && operation.width) {
            operation.height = Math.floor(operation.width / aspectRatio)
          }
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click={async () => {
          operation.width = operation.width - 10
          if (maintainAspectRatio && operation.width) {
            operation.height = Math.floor(operation.width / aspectRatio)
          }
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>
      <input
        min="1"
        max="100000"
        on:input={async (e) => {
          if (maintainAspectRatio && e.target.value) {
            operation.height = Math.floor(e.target.value / aspectRatio)
          }
          operation.width = e.target.value
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        bind:value={operation.width}
        on:keypress={preventKeys}
        type="number"
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pr-8 pl-10 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>
    <!-- Height -->

    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">H</div>
      <button
        on:click={async () => {
          operation.height = operation.height + 10
          if (maintainAspectRatio && operation.height) {
            operation.width = Math.floor(aspectRatio * operation.height)
          }
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click={async (e) => {
          operation.height = operation.height - 10
          if (maintainAspectRatio && operation.height) {
            operation.width = Math.floor(aspectRatio * operation.height)
          }
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>
      <input
        min="1"
        max="100000"
        on:input={async (e) => {
          if (maintainAspectRatio && e.target.value) {
            operation.width = Math.floor(aspectRatio * e.target.value)
          }
          operation.height = e.target.value
          if (operation.uploadImage) {
            operation.src = drawChecked(operation.width, operation.height)
            operation.image = await loadImage(operation.src)
          }
        }}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        bind:value={operation.height}
        type="number"
        class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
        placeholder="10"
      />
    </div>

    <button
      type="button"
      on:click={() => {
        if (operation.uploadImage) {
          aspectRatio = operation.width / operation.height
        }
        maintainAspectRatio = !maintainAspectRatio
        if (maintainAspectRatio) aspectRatio = operation.width / operation.height
      }}
      data-tooltip="Aspect"
      tooltip-position="top"
      class="{maintainAspectRatio ? 'bg-blue-500 text-white' : 'bg-transparent text-gray-g00'} flex items-center rounded-md border border-stone-700 p-2 text-lg hover:bg-zinc-900 focus:outline-none focus:ring-2 focus:ring-extraBlue-500 active:bg-extraBlue-500 disabled:cursor-not-allowed"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-link-simple" />
      </span>
    </button>
  </div>
</div>
